import type ChartScale from './ChartScale';

/**
 * Разметка графика на текущий рендер: границы панелей, шкалы и деления.
 * Считается один раз и нужна двоим: svg рисует по ней панели, а легенда и тулбар
 * выравниваются по левой и правой границе области построения
 */
class ChartLayout {
  readonly plotLeft: number;

  readonly plotRight: number;

  readonly plotTop: number;

  readonly plotBottom: number;

  /** Низ панели цены; без панели объёма совпадает с plotBottom */
  readonly priceBottom: number;

  /** Верх панели объёма; без неё совпадает с plotBottom */
  readonly volumeTop: number;

  readonly xScale: ChartScale;

  /** Шкала цены; null — цен в периоде нет */
  readonly yScale: ChartScale | null;

  readonly yTicks: number[];

  /** Шкала объёма; null — объёмов нет, панели объёма нет */
  readonly volumeScale: ChartScale | null;

  readonly volumeTicks: number[];

  constructor(
    plotLeft: number,
    plotRight: number,
    plotTop: number,
    plotBottom: number,
    priceBottom: number,
    volumeTop: number,
    xScale: ChartScale,
    yScale: ChartScale | null,
    yTicks: number[],
    volumeScale: ChartScale | null,
    volumeTicks: number[],
  ) {
    this.plotLeft = plotLeft;
    this.plotRight = plotRight;
    this.plotTop = plotTop;
    this.plotBottom = plotBottom;
    this.priceBottom = priceBottom;
    this.volumeTop = volumeTop;
    this.xScale = xScale;
    this.yScale = yScale;
    this.yTicks = yTicks;
    this.volumeScale = volumeScale;
    this.volumeTicks = volumeTicks;
  }
}

export default ChartLayout;
